import Vue from 'vue'
import Router, { Route, NavigationGuard } from 'vue-router'
import axios from '../rest.config';

Vue.use(Router);

import store from './store';

type Next = Parameters<NavigationGuard>[2];

const checkLoggedInUser = async function (to: Route, from: Route, next: Next): Promise<void> {

    try {
        await store.dispatch('checkStatus');
        if (store.getters.isLoggedIn) {
            next();
        }
        else {
            next("/login");
        }
    } catch (error: any) {
        console.log(error);
        next("/login");
    }
}

const enterUserPage = async function (to: Route, from: Route, next: Next): Promise<void> {
    try {
        await store.dispatch('checkStatus');
        if (!to.params.username) {
            next({ name: 'user-page', params: { 'username': store.getters.user } });
        }
        else if (store.getters.isAdmin || store.getters.user === to.params.username) {

            next();

        }
        else {
            console.log("else")
            next("/");
        }
    }
    catch (error: any) {
        console.log(error);
        next("/login");
    }
}

const checkAdminUser = async function (to: Route, from: Route, next: Next): Promise<void> {

    try {

        await store.dispatch('checkStatus');
        if (store.getters.isAdmin) {
            next();
        }
        else if (store.getters.isLoggedIn) {
            next({ name: 'user-page', params: { 'username': store.getters.user } })
        }
        else {
            next("/login");
        }
    } catch (error: any) {
        console.log(error);
        next("/login");
    }
}
const checkCanEditPuzzle = async function (to: Route, from: Route, next: Next): Promise<void> {
    try {
        await store.dispatch('checkStatus');
        const can = await store.dispatch('canEdit', { pid: to.params.puzzleid })
        if (store.getters.isAdmin || can) {
            next();
        }
        else {
            next("/");
        }
    } catch (error: any) {
        next("/")
    }
}

const warnLeaveGame = function (to: Route, from: Route, next: Next): void {

    next();
}


const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import(/* webpackChunkName: "about" */ './views/Home.vue')
        },
        {
            path: '/play',
            name: 'play',
            component: () => import(/* webpackChunkName: "about" */ './views/Play.vue')
        },
        {
            path: '/play/:puzzleid',
            name: 'puzzle',
            component: () => import(/* webpackChunkName: "about" */ './views/Puzzle.vue'),


        },
        {

            path: '/play/:puzzleid/responses',
            name: 'responses',
            component: () => import('./views/User/Responses.vue'),
            beforeEnter: checkLoggedInUser
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/admin',
            component: () => import(/* webpackChunkName: "about" */ './views/Admin.vue'),
            beforeEnter: checkAdminUser,
            children: [
                {
                    path: '',
                    name: 'admin',
                    component: () => import(/* webpackChunkName: "about" */ './components/Admin/AdminHome.vue'),
                },
                {
                    path: 'all/puzzles',
                    name: 'all-puzzles',
                    component: () => import(/* webpackChunkName: "about" */ './views/Admin/AllPuzzles.vue'),
                    beforeEnter: checkAdminUser
                },
                {
                    path: 'all/users',
                    name: 'all-users',
                    component: () => import(/* webpackChunkName: "about" */ './views/Admin/AllUsers.vue'),
                    beforeEnter: checkAdminUser
                },
                {
                    path: 'register',
                    name: 'register',
                    component: () => import('./views/Register.vue'),
                    beforeEnter: checkAdminUser
                },


            ]
        },
        {
            path: '/user/:username?',
            name: 'user-page',
            component: () => import('./views/User/UserEdit.vue'),
            beforeEnter: enterUserPage
        },
        {
            path: '/me/edit/password',
            name: 'updatePassword',
            component: () => import('./views/User/UpdateUserPassword.vue'),
            beforeEnter: checkLoggedInUser
        },
        {
            path: '/builder',
            name: 'builder',
            component: () => import(/* webpackChunkName: "about" */ './views/User/Builder.vue'),
            beforeEnter: checkLoggedInUser
        },
        {
            path: '/builder/:puzzleid',
            name: 'edit-puzzle',
            component: () => import(/* webpackChunkName: "about" */ './views/User/Builder.vue'),
            beforeEnter: checkCanEditPuzzle

        },
        {
            path: '/me/puzzles',
            name: 'user-puzzles2',
            component: () => import(/* webpackChunkName: "about" */ './views/User/UserPuzzles.vue'),
            beforeEnter: checkLoggedInUser
        },
        {
            path: '/me/puzzles/edit',
            redirect: { name: 'user-puzzles' }
        },
        {
            path: '/user/:username/puzzles',
            name: 'user-puzzles',
            component: () => import(/* webpackChunkName: "about" */ './views/User/UserPuzzles.vue'),
            beforeEnter: enterUserPage
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
            beforeEnter: async function (to, from, next) {
                store.dispatch('checkStatus').then(() => {
                    //console.log(store.getters);
                    if (store.getters.isLoggedIn) {
                        next({ name: 'user-puzzles' });
                    }
                    else {
                        next();
                    }
                }).catch(error => console.log("error", error));
            }
        },
        {
            path: '/signup',
            name: 'signup',
            component: () => import(/* webpackChunkName: "about" */ './views/Signup.vue'),
            beforeEnter: async function (to, from, next) {
                store.dispatch('checkStatus').then(() => {
                    //console.log(store.getters);
                    if (store.getters.isLoggedIn) {
                        next({ name: 'user-puzzles' });
                    }
                    else {
                        next();
                    }
                }).catch(error => console.log("error", error));
            }
        },

        {
            path: '/logout',
            name: 'logout',
            component: () => import(/* webpackChunkName: "about" */ './views/Logout.vue')
        },
        {
            path: '/err',
            name: 'error',
            component: () => import(/* webpackChunkName: "about" */ './views/Error.vue')
        },
        {
            path: '/cookies',
            name: 'cookies',
            component: () => import('./views/Cookies.vue')
        },
        {
            path: '*',
            name: 'notfound',
            component: () => import('./views/404.vue')
        }

    ]
})


export default router;
